import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * @param {...import("clsx").ClassValue} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * @param {unknown} value - coerced via Number(); non-finite results fall back to the muted tone.
 * @param {{ good?: number, ok?: number }} [thresholds]
 * @returns {{ text: string, bg: string, stroke: string }}
 */
export function scoreTone(value, { good = 75, ok = 50 } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return { text: "text-muted-foreground", bg: "bg-muted", stroke: "currentColor" };
  if (n >= good) return { text: "text-success", bg: "bg-success", stroke: "var(--success)" };
  if (n >= ok)   return { text: "text-warning", bg: "bg-warning", stroke: "var(--warning)" };
  return { text: "text-destructive", bg: "bg-destructive", stroke: "var(--destructive)" };
}
